module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-5 darker"
  }, [_c('h5', [_vm._v("Custom Sales Channel")]), _vm._v(" "), _c('div', {
    staticClass: "my-4 initial-height"
  }, [_vm._v("\n\t\t\tDefine your custom sales channels so you can choose them when adding new reservations. For each channel you can define default invoice settings.\n\t\t")]), _vm._v(" "), (_vm.getSalesChannels.length < 1) ? _c('div', {
    staticClass: "text-center dark fs-large w-100"
  }, [_vm._v("\n\t\t\tNo sales channels available\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-6 pl-0"
  }, [_c('div', {
    staticClass: "custom-fields"
  }, _vm._l((_vm.getSalesChannels), function(salesChannel) {
    return _c('div', {
      key: salesChannel.id,
      staticClass: "d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover"
    }, [_c('div', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(salesChannel.name))]), _vm._v(" "), _c('div', {
      staticClass: "withHover"
    }, [_c('span', {
      staticClass: "lighter bg-dark radius-normal fs-small px-2 pointer",
      on: {
        "click": function($event) {
          return _vm.editSalesCHannel(salesChannel)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), (!salesChannel.isImmutable) ? _c('i', {
      staticClass: "ico ico-delete fs-normal dark pointer ml-2",
      on: {
        "click": function($event) {
          return _vm.clickTrash(salesChannel)
        }
      }
    }) : _vm._e()])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn wide mt-4",
    on: {
      "click": _vm.AddSalesChannel
    }
  }, [_vm._v("Add Sales Channel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-5 pt-4 darker"
  }, [_c('h5', [_vm._v("Origins")]), _vm._v(" "), _c('div', {
    staticClass: "my-4"
  }, [_vm._v("\n\t\t\tDefine your Origins so you can choose them when adding new reservations.\n\t\t")]), _vm._v(" "), (_vm.getOrigins.length < 1) ? _c('div', {
    staticClass: "text-center dark fs-large w-100"
  }, [_vm._v("\n\t\t\tNo origins available\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-6 pl-0"
  }, [(_vm.getOrigins.length > 0) ? _c('div', {
    staticClass: "custom-fields"
  }, _vm._l((_vm.getOrigins), function(origin) {
    return _c('div', {
      key: origin.id,
      staticClass: "d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover"
    }, [_c('div', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(origin.name))]), _vm._v(" "), _c('div', {
      staticClass: "withHover"
    }, [_c('span', {
      staticClass: "lighter bg-dark radius-normal fs-small px-2 pointer",
      on: {
        "click": function($event) {
          return _vm.editOrigin(origin)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('i', {
      staticClass: "ico ico-delete fs-normal dark pointer ml-2",
      on: {
        "click": function($event) {
          return _vm.clickTrashOrigin(origin)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wide mt-4",
    on: {
      "click": _vm.AddOrigin
    }
  }, [_vm._v("Add Origin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-5 pt-4 darker"
  }, [_c('h5', [_vm._v("Segments")]), _vm._v(" "), _c('div', {
    staticClass: "my-4"
  }, [_vm._v("\n\t\t\tDefine your Segments so you can choose them when adding new reservations.\n\t\t")]), _vm._v(" "), (_vm.getSegments.length < 1) ? _c('div', {
    staticClass: "text-center dark fs-large w-100"
  }, [_vm._v("\n\t\t\tNo segments available\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-6 pl-0"
  }, [(_vm.getSegments.length > 0) ? _c('div', {
    staticClass: "custom-fields"
  }, _vm._l((_vm.getSegments), function(segment) {
    return _c('div', {
      key: segment.id,
      staticClass: "d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover"
    }, [_c('div', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(segment.name))]), _vm._v(" "), _c('div', {
      staticClass: "withHover"
    }, [_c('span', {
      staticClass: "lighter bg-dark radius-normal fs-small px-2 pointer",
      on: {
        "click": function($event) {
          return _vm.editSegment(segment)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('i', {
      staticClass: "ico ico-delete fs-normal dark pointer ml-2",
      on: {
        "click": function($event) {
          return _vm.clickTrashSegment(segment)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wide mt-4",
    on: {
      "click": _vm.AddSegment
    }
  }, [_vm._v("Add Segment")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-38ae664d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ae664d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabSalesChannels.vue
// module id = 2545
// module chunks = 0